export { default } from './ResultatsCerca';
